"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3733],{

/***/ 41292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Res; },
/* harmony export */   "u": function() { return /* binding */ PaymentType; }
/* harmony export */ });
var Res;
(function(Res) {
    Res["Percentage"] = "percentage";
    Res["Pixels"] = "pixels";
})(Res || (Res = {}));
var PaymentType;
(function(PaymentType) {
    PaymentType["Paypal"] = "paypal";
    PaymentType["Card"] = "card";
    PaymentType["External"] = "external";
    PaymentType["NoPaid"] = "noPaid";
    PaymentType["Stripe"] = "stripe";
})(PaymentType || (PaymentType = {}));


/***/ }),

/***/ 81766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ LockLocationType; },
/* harmony export */   "BY": function() { return /* binding */ EMPTY_LOCATION_ITEM; },
/* harmony export */   "CP": function() { return /* binding */ ConditionType; },
/* harmony export */   "Gn": function() { return /* binding */ LockType; },
/* harmony export */   "KO": function() { return /* binding */ GameLockPathTransitionType; },
/* harmony export */   "LV": function() { return /* binding */ Res; },
/* harmony export */   "Tl": function() { return /* binding */ LOCK_SOLUTION_SEPARATOR; },
/* harmony export */   "Xr": function() { return /* binding */ ScoreType; },
/* harmony export */   "lA": function() { return /* binding */ Game; },
/* harmony export */   "py": function() { return /* binding */ EntityType; },
/* harmony export */   "zc": function() { return /* binding */ ContentType; }
/* harmony export */ });
/* unused harmony exports GameTimerType, LockLocationTypeLabel, HintContentType, FinishScreenTemplate, GameGeneral, GameCondition, GameLockQuestion, GameLockPath, GameLock, GameHint */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71418);
/* harmony import */ var _game_GameBook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97741);



/* eslint-disable camelcase */ // eslint-disable-next-line max-classes-per-file

var Res;
(function(Res) {
    Res["Percentage"] = "percentage";
    Res["Pixels"] = "pixels";
})(Res || (Res = {}));
var GameTimerType;
(function(GameTimerType) {
    GameTimerType["CountDown"] = "countdown";
    GameTimerType["StopWatch"] = "stopwatch";
})(GameTimerType || (GameTimerType = {}));
var ScoreType;
(function(ScoreType) {
    ScoreType["Progress"] = "progress";
    ScoreType["Points"] = "points";
})(ScoreType || (ScoreType = {}));
var LockType;
(function(LockType) {
    LockType["Code"] = "code";
    LockType["Keyboard"] = "keyboard";
    LockType["Sequence"] = "sequence";
    LockType["PopUpTrivia"] = "popUpTrivia";
    LockType["CollectItems"] = "collectItems";
    LockType["Path"] = "path";
    LockType["Genially"] = "genial_ly";
})(LockType || (LockType = {}));
var LockLocationType;
(function(LockLocationType) {
    LockLocationType["Tag"] = "tag";
    LockLocationType["TransparentBox"] = "transparentBox";
    LockLocationType["vsItem"] = "vsItem";
    LockLocationType["Polygon"] = "Polygon";
    LockLocationType["vsVideo"] = "vsVideo";
    LockLocationType["vsImage"] = "vsImage";
})(LockLocationType || (LockLocationType = {}));
var LockLocationTypeLabel;
(function(LockLocationTypeLabel) {
    LockLocationTypeLabel["tag"] = "tag";
    LockLocationTypeLabel["transparentBox"] = "transparentBox";
    LockLocationTypeLabel["vsItem"] = "VSitem";
})(LockLocationTypeLabel || (LockLocationTypeLabel = {}));
var EntityType;
(function(EntityType) {
    EntityType["Tag"] = "tag";
    EntityType["Sweep"] = "sweep";
    EntityType["Popup"] = "popup";
    EntityType["Polygon"] = "polygon";
    EntityType["VSItem"] = "vsItem";
    EntityType["VSImage"] = "vsImage";
    EntityType["VSVideo"] = "vsVideo";
    EntityType["VSHTML"] = "vsHTML";
})(EntityType || (EntityType = {}));
var ConditionType;
(function(ConditionType) {
    ConditionType["HIDE"] = "hide";
    ConditionType["REVEAL"] = "reveal";
})(ConditionType || (ConditionType = {}));
var HintContentType;
(function(HintContentType) {
    HintContentType["Text"] = "text";
    HintContentType["Picture"] = "picture";
    HintContentType["Video"] = "video";
})(HintContentType || (HintContentType = {}));
var ContentType;
(function(ContentType) {
    ContentType["Sound"] = "sound";
    ContentType["Picture"] = "picture";
    ContentType["Text"] = "text";
    ContentType["Video"] = "video";
    ContentType["ExperiencePopupImage"] = "experiencePopupImage";
    ContentType["ExperiencePopupVideo"] = "experiencePopupVideo";
})(ContentType || (ContentType = {}));
var LOCK_SOLUTION_SEPARATOR = "|";
var EMPTY_LOCATION_ITEM = "-1";
var DEFAULT_RES = Res.Pixels;
var DEFAULT_WIDTH = 80;
var DEFAULT_HEIGHT = 60;
var FinishScreenTemplate;
(function(FinishScreenTemplate) {
    FinishScreenTemplate["DEFAULT"] = "default";
    FinishScreenTemplate["CUSTOM"] = "custom";
})(FinishScreenTemplate || (FinishScreenTemplate = {}));
var GameGeneral = function GameGeneral() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, GameGeneral);
    this.id = model.id || null;
    this.name = model.name || null;
    this.credits = model.credits || null;
    this.greetingRes = model.greetingRes || DEFAULT_RES;
    this.greetingImg = model.greetingImg || null;
    this.greetingImgW = model.greetingImgW || DEFAULT_WIDTH;
    this.greetingImgH = model.greetingImgH || DEFAULT_HEIGHT;
    this.greetingImgMob = model.greetingImgMob || null;
    this.greetingImgMobW = model.greetingImgMobW || DEFAULT_WIDTH;
    this.greetingImgMobH = model.greetingImgMobH || DEFAULT_HEIGHT;
    this.greetingVideo = model.greetingVideo || null;
    this.greetingMobVideo = model.greetingMobVideo || null;
    this.timerType = model.timerType || GameTimerType.CountDown;
    this.limitTime = model.limitTime || 0;
    this.timeUpRes = model.timeUpRes || DEFAULT_RES;
    this.timeUpImg = model.timeUpImg || null;
    this.timeUpImgW = model.timeUpImgW || DEFAULT_WIDTH;
    this.timeUpImgH = model.timeUpImgH || DEFAULT_HEIGHT;
    this.timeUpImgMob = model.timeUpImgMob || null;
    this.timeUpImgMobW = model.timeUpImgMobW || DEFAULT_WIDTH;
    this.timeUpImgMobH = model.timeUpImgMobH || DEFAULT_HEIGHT;
    this.timeUpVideo = model.timeUpVideo || null;
    this.timeUpMobVideo = model.timeUpMobVideo || null;
    this.scoreType = model.scoreType || ScoreType.Progress;
    this.lock_points = model.lock_points || 0;
    this.nextHintTime = model.nextHintTime || 0;
    this.scoreHint1 = model.scoreHint1 || 0;
    this.scoreHint2 = model.scoreHint2 || 0;
    this.scoreSolution = model.scoreSolution || 0;
    this.tutorialRes = model.tutorialRes || DEFAULT_RES;
    this.tutorialImg = model.tutorialImg || null;
    this.tutorialImgW = model.tutorialImgW || DEFAULT_WIDTH;
    this.tutorialImgH = model.tutorialImgH || DEFAULT_HEIGHT;
    this.tutorialImgMob = model.tutorialImgMob || null;
    this.tutorialImgMobW = model.tutorialImgMobW || DEFAULT_WIDTH;
    this.tutorialImgMobH = model.tutorialImgMobH || DEFAULT_HEIGHT;
    this.tutorialVideo = model.tutorialVideo || null;
    this.tutorialMobVideo = model.tutorialMobVideo || null;
    this.autoplayTutorial = model.autoplayTutorial || false;
    this.subscriptionId = model.subscriptionId || null;
    this.paid = model.paid || false;
    this.introClip = model.introClip || false;
    this.introClipUrl = model.introClipUrl || null;
    this.outroClip = model.outroClip || false;
    this.outroClipUrl = model.outroClipUrl || null;
    this.answerIndicatorOn = model.answerIndicatorOn || false;
    this.finishScreenOn = model.finishScreenOn || false;
    this.finishScreenType = model.finishScreenType || FinishScreenTemplate.DEFAULT;
    this.finishScreenTitle = model.finishScreenTitle;
    var _finishScreenShareOn;
    this.finishScreenShareOn = (_finishScreenShareOn = model.finishScreenShareOn) !== null && _finishScreenShareOn !== void 0 ? _finishScreenShareOn : false;
    var _finishScreenLeaderboardOn;
    this.finishScreenLeaderboardOn = (_finishScreenLeaderboardOn = model.finishScreenLeaderboardOn) !== null && _finishScreenLeaderboardOn !== void 0 ? _finishScreenLeaderboardOn : false;
    var _finishScreenRateOn;
    this.finishScreenRateOn = (_finishScreenRateOn = model.finishScreenRateOn) !== null && _finishScreenRateOn !== void 0 ? _finishScreenRateOn : false;
    this.timerOn = model.timerOn || false;
    this.progressOn = model.progressOn || false;
    this.hintsOn = model.hintsOn || false;
    this.backpackOn = model.backpackOn || false;
    this.showBackpackByDefault = model.showBackpackByDefault || false;
    this.gameBookOn = model.gameBookOn || false;
    this.buttonSound = model.buttonSound || false;
    this.buttonSoundUrl = model.buttonSoundUrl || null;
    this.registration = model.registration || false;
};
var GameCondition = function GameCondition() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, GameCondition);
    this.id = model.id || null;
    this.gameId = model.gameId || null;
    this.name = model.name || null;
    this.lock_ids = model.lock_ids || null;
    this.conditionType = model.conditionType || ConditionType.REVEAL;
    this.entity_type = model.entity_type || null;
    this.entity_ids = model.entity_ids || null;
    this.color = model.color || null;
    this.teleportToSweep = model.teleportToSweep || null;
    this.content_type = model.content_type || ContentType.Text;
    this.content_value = model.content_value || null;
    this.gameBackpack = model.gameBackpack || false;
    this.autoPlay = model.autoPlay || false;
    this.fullscreen = model.fullscreen || false;
    this.res = model.res || Res.Percentage;
    this.resMobile = model.resMobile || Res.Percentage;
    this.width = model.width || 60;
    this.height = model.height || 60;
    this.widthMobile = model.widthMobile || 60;
    this.heightMobile = model.heightMobile || 60;
    this.lockPathId = model.lockPathId || null;
    this.experienceTitle = model.experienceTitle || null;
    this.experienceDescription = model.experienceDescription || null;
    this.autoClose = model.autoClose || false;
    this.teleportLocationType = model.teleportLocationType;
    this.teleportLocationTourLink = model.teleportLocationTourLink;
};
var GameLockQuestion = function GameLockQuestion() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, GameLockQuestion);
    this.id = model.id || null;
    this.title = model.title || null;
    this.answer1 = model.answer1 || null;
    this.answer2 = model.answer2 || null;
    this.answer3 = model.answer3 || null;
    this.answer4 = model.answer4 || null;
    this.correctAnswer = model.correctAnswer || null;
};
var GameLockPathTransitionType;
(function(GameLockPathTransitionType) {
    GameLockPathTransitionType["FADEOUT"] = "fadeout";
    GameLockPathTransitionType["FLY"] = "fly";
    GameLockPathTransitionType["INSTANT"] = "instant";
})(GameLockPathTransitionType || (GameLockPathTransitionType = {}));
var GameLockPath = function GameLockPath() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, GameLockPath);
    this.id = model.id || null;
    this.title = model.title || null;
    this.sweepUuid = model.sweepUuid || null;
    this.description = model.description || null;
    this.locationType = model.locationType || null;
    this.locationItem = model.locationItem ? parseInt(model.locationItem, 10) : null;
    this.triggerType = model.triggerType || null;
    this.triggerItem = model.triggerItem ? parseInt(model.triggerItem, 10) : null;
    this.transitionType = model.transitionType || GameLockPathTransitionType.INSTANT;
};
var GameLockPathSetting = function GameLockPathSetting(model) {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, GameLockPathSetting);
    this.id = (model === null || model === void 0 ? void 0 : model.id) || null;
    this.gameLockId = (model === null || model === void 0 ? void 0 : model.gameLockId) || null;
    this.colorBackground = (model === null || model === void 0 ? void 0 : model.colorBackground) || "#ffffff";
    this.colorText = (model === null || model === void 0 ? void 0 : model.colorText) || "#ffffff";
    this.colorButton = (model === null || model === void 0 ? void 0 : model.colorButton) || "#ea475c";
    this.colorButtonText = (model === null || model === void 0 ? void 0 : model.colorButtonText) || "#ffffff";
    this.opacityBackground = (model === null || model === void 0 ? void 0 : model.opacityBackground) || 0.25;
    this.opacityText = (model === null || model === void 0 ? void 0 : model.opacityText) || 1;
    this.opacityButton = (model === null || model === void 0 ? void 0 : model.opacityButton) || 1;
    this.opacityButtonText = (model === null || model === void 0 ? void 0 : model.opacityButtonText) || 1;
    this.icon = (model === null || model === void 0 ? void 0 : model.icon) || null;
};
var GameLock = function GameLock() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, GameLock);
    this.id = model.id || null;
    this.name = model.name || null;
    this.type = model.type || null;
    this.url = model.url || null;
    this.locationType = model.locationType || null;
    this.locationItem = model.locationItem || null;
    this.solution = model.solution || null;
    this.correctMusic = model.correctMusic || null;
    this.incorrectMusic = model.incorrectMusic || null;
    this.finishMusic = model.finishMusic || null;
    this.questions = model.questions && model.questions.map(function(question) {
        return new GameLockQuestion(question);
    }) || [];
    this.paths = ((model === null || model === void 0 ? void 0 : model.paths) || []).map(function(path) {
        return new GameLockPath(path);
    });
    var ref;
    this.keepHighlight = (ref = model === null || model === void 0 ? void 0 : model.keepHighlight) !== null && ref !== void 0 ? ref : true;
    this.resetHighlight = model.resetHighlight || 0;
    this.vsRes = model.vsRes || Res.Percentage;
    this.vsImg = model.vsImg || null;
    this.vsImgW = model.vsImgW || DEFAULT_WIDTH;
    this.vsImgH = model.vsImgH || DEFAULT_HEIGHT;
    this.vsMobImg = model.vsMobImg || null;
    this.vsMobImgW = model.vsMobImgW || DEFAULT_WIDTH;
    this.vsMobImgH = model.vsMobImgH || DEFAULT_HEIGHT;
    this.collected = [];
    this.icon = model.icon || null;
    var _hideItems;
    this.hideItems = (_hideItems = model.hideItems) !== null && _hideItems !== void 0 ? _hideItems : false;
    var _allowSkipping;
    this.allowSkipping = (_allowSkipping = model.allowSkipping) !== null && _allowSkipping !== void 0 ? _allowSkipping : false;
    var _last;
    this.last = (_last = model.last) !== null && _last !== void 0 ? _last : false;
    this.point = model.point || 0;
    var _timerEnabled;
    this.timerEnabled = (_timerEnabled = model.timerEnabled) !== null && _timerEnabled !== void 0 ? _timerEnabled : false;
    var _confettiEnabled;
    this.confettiEnabled = (_confettiEnabled = model.confettiEnabled) !== null && _confettiEnabled !== void 0 ? _confettiEnabled : false;
    var _guidCanClose;
    this.guidCanClose = (_guidCanClose = model.guidCanClose) !== null && _guidCanClose !== void 0 ? _guidCanClose : false;
    var _lockTimer;
    this.lockTimer = (_lockTimer = model.lockTimer) !== null && _lockTimer !== void 0 ? _lockTimer : 0;
    var _multipleAttempts;
    this.multipleAttempts = (_multipleAttempts = model.multipleAttempts) !== null && _multipleAttempts !== void 0 ? _multipleAttempts : false;
    var _lockPopUpCanBeClosed;
    this.lockPopUpCanBeClosed = (_lockPopUpCanBeClosed = model.lockPopUpCanBeClosed) !== null && _lockPopUpCanBeClosed !== void 0 ? _lockPopUpCanBeClosed : false;
    var _guidCanBeClosed;
    this.guidCanBeClosed = (_guidCanBeClosed = model.guidCanBeClosed) !== null && _guidCanBeClosed !== void 0 ? _guidCanBeClosed : false;
    var _quantityOfAttempts;
    this.quantityOfAttempts = (_quantityOfAttempts = model.quantityOfAttempts) !== null && _quantityOfAttempts !== void 0 ? _quantityOfAttempts : 0;
    this.pathSetting = new GameLockPathSetting(model.pathSetting);
    var _autoOpenDestination;
    this.autoOpenDestination = (_autoOpenDestination = model.autoOpenDestination) !== null && _autoOpenDestination !== void 0 ? _autoOpenDestination : false;
    this.hint = model.hint || null;
    this.description = model.description || "";
    this.previousStep = model.previousStep || false;
};
var GameHint = function GameHint() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, GameHint);
    this.id = model.id || null;
    this.gameId = model.gameId || null;
    this.name = model.name || null;
    this.lockId = model.lockId || null;
    this.hint1_active = model.hint1_active || false;
    this.hint1_type = model.hint1_type || null;
    this.hint1_value = model.hint1_value || null;
    this.hint1_deductPoints = model.hint1_deductPoints || 0;
    this.hint1_unlockTime = model.hint1_unlockTime || 0;
    this.hint2_active = model.hint2_active || false;
    this.hint2_type = model.hint2_type || null;
    this.hint2_value = model.hint2_value || null;
    this.hint2_deductPoints = model.hint2_deductPoints || 0;
    this.hint2_unlockTime = model.hint2_unlockTime || 0;
    this.solution_active = model.solution_active || false;
    this.solution_type = model.solution_type || null;
    this.solution_value = model.solution_value || null;
    this.solution_deductPoints = model.solution_deductPoints || 0;
    this.solution_unlockTime = model.solution_unlockTime || 0;
};
var Game = /*#__PURE__*/ function(GameGeneral) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Game, GameGeneral);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Game);
    function Game() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Game);
        var _this;
        var ref;
        _this = _super.call(this, model);
        _this.id = model.id || null;
        _this.locks = ((ref = model.locks) === null || ref === void 0 ? void 0 : ref.length) && model.locks.filter(function(lock) {
            return lock.type !== LockType.Path;
        }).map(function(lock) {
            return new GameLock(lock);
        }) || [];
        var paths = ((model === null || model === void 0 ? void 0 : model.locks) || []).find(function(lock) {
            return lock.type === LockType.Path;
        });
        _this.paths = paths ? new GameLock(paths) : null;
        _this.hints = model.hints && model.hints.map(function(hint) {
            return new GameHint(hint);
        }) || [];
        _this.conditions = model.conditions && model.conditions.map(function(condition) {
            return new GameCondition(condition);
        }) || [];
        _this.book = model.book ? new _game_GameBook__WEBPACK_IMPORTED_MODULE_0__/* .GameBook */ .Rw(model.book) : null;
        return _this;
    }
    return Game;
}(GameGeneral);


/***/ }),

/***/ 78073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ MenuType; }
/* harmony export */ });
var MenuType;
(function(MenuType) {
    MenuType["Treedis"] = "treedis";
    MenuType["Matterport"] = "matterport";
    MenuType["MatterportInstant"] = "matterport-instant";
    MenuType["MatterportLabel"] = "matterport-label";
    MenuType["MatterportFloor"] = "matterport-floor";
    MenuType["Popup"] = "popup";
    MenuType["Tab"] = "tab";
    MenuType["Tag"] = "tag";
    MenuType["Panorama"] = "panorama";
    MenuType["Product"] = "product";
    MenuType["Iframe"] = "iframe";
})(MenuType || (MenuType = {}));


/***/ }),

/***/ 97741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rw": function() { return /* binding */ GameBook; },
/* harmony export */   "_U": function() { return /* binding */ ChapterType; },
/* harmony export */   "u6": function() { return /* binding */ GameBookType; }
/* harmony export */ });
/* unused harmony export GameBookChapter */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71418);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14293);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isNaN__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7654);
/* harmony import */ var lodash_isNaN__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isNaN__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41292);
/* harmony import */ var _components_tour_game_gameBook_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81389);



// eslint-disable-next-line max-classes-per-file




var ChapterType;
(function(ChapterType) {
    ChapterType["Tag"] = "tag";
    ChapterType["Polygon"] = "polygon";
    ChapterType["VSItem"] = "vsItem";
    ChapterType["VSImage"] = "vsImage";
    ChapterType["VSVideo"] = "vsVideo";
})(ChapterType || (ChapterType = {}));
var GameBookType;
(function(GameBookType) {
    GameBookType["Open"] = "open";
    GameBookType["Close"] = "close";
})(GameBookType || (GameBookType = {}));
var ImageSettings = function ImageSettings(model) {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ImageSettings);
    this.res = model.res || _Common__WEBPACK_IMPORTED_MODULE_2__/* .Res.Percentage */ .L.Percentage;
    this.resMobile = model.resMobile || _Common__WEBPACK_IMPORTED_MODULE_2__/* .Res.Percentage */ .L.Percentage;
    this.width = model.width || 80;
    this.height = model.height || 60;
    this.widthMobile = model.widthMobile || 80;
    this.heightMobile = model.heightMobile || 60;
    this.img = model.img || null;
    this.imgMobile = model.imgMobile || null;
};
var GameBookChapter = /*#__PURE__*/ function(ImageSettings) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(GameBookChapter, ImageSettings);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(GameBookChapter);
    function GameBookChapter(model) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GameBookChapter);
        var _this;
        _this = _super.call(this, model);
        _this.id = model.id || null;
        _this.title = model.title || null;
        _this.type = model.type || null;
        _this.value = model.value || null;
        _this.order = model.order || null;
        _this.sweepUuid = model.sweepUuid || null;
        _this.description = model.description || null;
        _this.locationType = model.locationType || _components_tour_game_gameBook_types__WEBPACK_IMPORTED_MODULE_3__/* .GameBookLocationType.sweep */ .d.sweep;
        _this.locationTourLink = model.locationTourLink || "";
        return _this;
    }
    return GameBookChapter;
}(ImageSettings);
var GameBook = /*#__PURE__*/ function(ImageSettings) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(GameBook, ImageSettings);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(GameBook);
    function GameBook() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GameBook);
        var _this;
        var ref;
        _this = _super.call(this, model);
        _this.id = model.id || null;
        _this.description = model.description || null;
        _this.chapters = (model === null || model === void 0 ? void 0 : (ref = model.chapters) === null || ref === void 0 ? void 0 : ref.map(function(chapter) {
            return new GameBookChapter(chapter);
        })) || [];
        _this.gameId = model.gameId || null;
        _this.type = model.type || GameBookType.Close;
        _this.chapterLocked = lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default()(model.chapterLocked) ? true : model.chapterLocked;
        _this.openByDefault = lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default()(model.openByDefault) ? false : model.openByDefault;
        _this.backgroundColor = model.backgroundColor || "#000000";
        _this.backgroundOpacity = lodash_isNaN__WEBPACK_IMPORTED_MODULE_1___default()(model.backgroundOpacity) ? 0.5 : model.backgroundOpacity;
        _this.textColor = model.textColor || "#ffffff";
        _this.buttonColor = model.buttonColor || "#2055FF";
        return _this;
    }
    return GameBook;
}(ImageSettings);


/***/ }),

/***/ 81389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ GameBookLocationType; }
/* harmony export */ });
var GameBookLocationType;
(function(GameBookLocationType) {
    GameBookLocationType["sweep"] = "sweep";
    GameBookLocationType["tourLink"] = "tourLink";
})(GameBookLocationType || (GameBookLocationType = {}));


/***/ }),

/***/ 66870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ closeTagPanelObserver; },
  "vQ": function() { return /* reexport */ util_all/* copyToClipboard */.vQ; },
  "fg": function() { return /* reexport */ util_all/* downloadFloorPlan */.fg; },
  "rQ": function() { return /* reexport */ util_all/* fetchData */.rQ; },
  "BS": function() { return /* reexport */ util_all/* getBaseURL */.BS; },
  "Dv": function() { return /* reexport */ util_all/* getQueryVariable */.Dv; },
  "u6": function() { return /* reexport */ getSweepsPath; },
  "R6": function() { return /* reexport */ util_all/* getTicketTypeCount */.R6; },
  "bo": function() { return /* reexport */ util_all/* getVersion */.bo; },
  "rp": function() { return /* reexport */ util_all/* getVideoLink */.rp; },
  "oo": function() { return /* reexport */ util_all/* hexToRgb */.oo; },
  "o$": function() { return /* reexport */ analytic/* sendToGA */.o$; },
  "D2": function() { return /* reexport */ errorObserver; },
  "v2": function() { return /* reexport */ mpPasswordFormObserver; },
  "p$": function() { return /* reexport */ setTagPanelObserver; },
  "pb": function() { return /* reexport */ util_all/* ticketingTypes */.pb; },
  "OZ": function() { return /* reexport */ popups/* toggleContactPopup */.O; }
});

// UNUSED EXPORTS: DEFAULT_TAG_COLOR, TAG_DEFAULT, buildLink, calculateMobileHeight, createGA, customSelectStyles, ecommerceDefaultColorBlackSelect, getAllQueryVariables, getBucketLink, getCurrency, getICEServers, getLocation, getPanoramaIndex, getSymbolFromCurrency, getYoutubeVideoQueryVariable, isVimeoUrl, loadModel, login, moveToMPLabels, navigateToTag, newEcommerceStyles, openLinkInNewTab, openTagIframe, openVsImageIframe, openVsObjectIframe, openVsVideoIframe, openedPanoHotspot, preventTagAction, round, setGA, setWhiteLabel, startGA, takePano, takeScreenshot, toggleExternalPopup, updatePanoRotation, validateEmail

// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./components/util/analytic.ts
var analytic = __webpack_require__(83784);
// EXTERNAL MODULE: ./components/util/axios.ts
var axios = __webpack_require__(54453);
// EXTERNAL MODULE: ./components/util/constants.ts
var constants = __webpack_require__(46021);
;// CONCATENATED MODULE: ./components/util/currency.ts
var currency = {
    DE: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    FR: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    AT: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    BE: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    CY: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    EE: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    FI: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    GR: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    IE: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    IT: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    LV: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    LT: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    LU: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    MT: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    NL: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    PT: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    SK: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    SI: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    ES: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    EZ: {
        ISO: "EUR",
        SYM: "\u20AC"
    },
    GB: {
        ISO: "GBP",
        SYM: "\xa3"
    },
    US: {
        ISO: "USD",
        SYM: "$"
    }
};
var defaultCur = {
    ISO: "USD",
    SYM: "$"
};
function getCurrency(country) {
    var cur = defaultCur;
    if (currency[country]) cur = currency[country];
    return cur;
}
function getSymbolFromCurrency(cur) {
    var ex = Object.values(currency).find(function(x) {
        return x.ISO === cur;
    });
    ex = ex || defaultCur;
    return ex.SYM;
}

// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 328 modules
var dist = __webpack_require__(78734);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
;// CONCATENATED MODULE: ./components/util/pathFinder.ts





var PathNode = /*#__PURE__*/ function() {
    "use strict";
    function PathNode(sweep, pathLengthFromStart, cameFrom, estimatePathLength) {
        (0,_class_call_check/* default */.Z)(this, PathNode);
        this.sweep = sweep;
        this.pathLengthFromStart = pathLengthFromStart;
        this.cameFrom = cameFrom;
        this.estimatePathLength = estimatePathLength;
    }
    var _proto = PathNode.prototype;
    _proto.estimateFullPathLength = function estimateFullPathLength() {
        return this.pathLengthFromStart + this.estimatePathLength;
    };
    return PathNode;
}();
var getPathLength = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(from, to) {
        var THREE, vector1, vector2;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,dist/* iTHREE */.Sc)();
                case 2:
                    THREE = _ctx.sent;
                    vector1 = new THREE.Vector3(from.x, from.y, from.z);
                    vector2 = new THREE.Vector3(to.x, to.y, to.z);
                    return _ctx.abrupt("return", vector1.distanceTo(vector2));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPathLength(from, to) {
        return _ref.apply(this, arguments);
    };
}();
var getNeighbours = function(neighbours, currentNode, endSweep, sweeps) {
    return neighbours.reduce(function(acc, neighborIndex) {
        var sweep = sweeps.find(function(s) {
            return s.index === neighborIndex;
        });
        if (sweep) {
            acc.push(new PathNode(sweep, getPathLength(currentNode.sweep.position, sweep.position), currentNode, getPathLength(sweep.position, endSweep.position)));
        }
        return acc;
    }, []);
};
var getSweepsPath = function(allSweeps, start, end) {
    var sweeps = allSweeps.filter(function(s) {
        return s.tags.indexOf("showcase") || s.uuid === start || s.uuid === end;
    });
    var startSweep = sweeps.find(function(s) {
        return s.uuid === start;
    });
    var endSweep = sweeps.find(function(s) {
        return s.uuid === end;
    });
    var closedSet = [];
    var openSet = [];
    var startNode = new PathNode(startSweep, 0, null, getPathLength(startSweep.position, endSweep.position));
    openSet.push(startNode);
    while(openSet.length > 0){
        var currentNode = sortBy_default()(openSet, [
            function(o) {
                return o.estimateFullPathLength();
            }
        ])[0];
        if (currentNode.sweep.uuid === end) {
            closedSet.push(currentNode);
            var path = [];
            for(var i = 0; i < closedSet.length; i += 1){
                var node = closedSet[i];
                var nextNode = closedSet[i + 1];
                path.push({
                    id: node.sweep.uuid,
                    position: node.sweep.position,
                    rotation: node.sweep.rotation,
                    next: nextNode ? {
                        id: nextNode.sweep.uuid,
                        position: nextNode.sweep.position,
                        rotation: nextNode.sweep.rotation
                    } : null
                });
            }
            return path;
        }
        openSet = openSet.filter(function(set) {
            return set.sweep.uuid !== currentNode.sweep.uuid;
        });
        closedSet.push(currentNode);
        var neighbors = getNeighbours(currentNode.sweep.neighbors, currentNode, endSweep, sweeps);
        // eslint-disable-next-line no-loop-func
        neighbors.forEach(function(neighbor) {
            if (closedSet.some(function(set) {
                return set.sweep.index === neighbor.sweep.index;
            })) {
                return;
            }
            var openNode = openSet.find(function(set) {
                return set.sweep.index === neighbor.sweep.index;
            });
            if (!openNode) {
                openSet.push(neighbor);
            } else if (openNode.pathLengthFromStart > neighbor.pathLengthFromStart) {
                openNode.cameFrom = currentNode;
                openNode.pathLengthFromStart = neighbor.pathLengthFromStart;
            }
        });
    }
    return null;
};

// EXTERNAL MODULE: ./components/util/popups.ts
var popups = __webpack_require__(62818);
// EXTERNAL MODULE: ./components/util/sdk.ts + 2 modules
var sdk = __webpack_require__(68687);
// EXTERNAL MODULE: ./components/util/socket.ts
var socket = __webpack_require__(13607);
// EXTERNAL MODULE: ./components/util/styles.ts
var styles = __webpack_require__(24069);
;// CONCATENATED MODULE: ./components/util/observers/errorObserver.ts
function setErrorObserver(element, callback) {
    if (!element) return;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mutation = _step.value;
                if (mutation.type === "attributes") {
                    var pageCrashed = !mutation.target.classList.contains("hidden");
                    callback(pageCrashed, observer);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        attributes: true
    });
}
/* harmony default export */ var errorObserver = (setErrorObserver);

;// CONCATENATED MODULE: ./components/util/observers/mpPasswordFormObserver.ts
function setMPPasswordFormObserver(element, onShow, onHide) {
    if (!element) return null;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mutation = _step.value;
                if (mutation.type === "childList") {
                    if (mutation.target.id === "showcase-password-container") {
                        var showForm = !!mutation.target.querySelector(".sc-password-ui");
                        if (showForm) {
                            onShow();
                        } else {
                            onHide();
                            observer.disconnect();
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        childList: true,
        subtree: true
    });
    return observer;
}
/* harmony default export */ var mpPasswordFormObserver = (setMPPasswordFormObserver);

;// CONCATENATED MODULE: ./components/util/observers/mpTagPanelObserver.ts
function closeTagPanelObserver(element) {
    if (!element) return;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function(_iterator, _step) {
                var mutation = _step.value;
                if (mutation.type === "attributes") {
                    var panelOpens = mutation.target.classList.contains("panel-collapsed") || mutation.target.classList.contains("panel-open");
                    if (panelOpens) {
                        setTimeout(function() {
                            var closeButton = mutation.target.querySelector("button");
                            closeButton.click();
                        }, 100);
                        observer.disconnect();
                    }
                }
            };
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop(_iterator, _step);
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        attributes: true
    });
}
function setTagPanelObserver(element, callback) {
    if (!element) return;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mutation = _step.value;
                if (mutation.type === "attributes") {
                    var panelOpens = mutation.target.classList.contains("panel-collapsed") || mutation.target.classList.contains("panel-open");
                    callback(panelOpens, observer);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        attributes: true
    });
}


;// CONCATENATED MODULE: ./components/util/observers/index.ts




;// CONCATENATED MODULE: ./components/util/index.ts














/***/ }),

/***/ 62818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ toggleExternalPopup; },
/* harmony export */   "O": function() { return /* binding */ toggleContactPopup; }
/* harmony export */ });
/* harmony import */ var _all__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40488);
/* harmony import */ var _analytic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83784);


function toggleExternalPopup(url, iframeSettings) {
    var externalPopupUrl = url;
    if (url && (url.includes("youtu.be") || url.includes("youtube.com") || url.includes("vimeo.com"))) {
        externalPopupUrl = (0,_all__WEBPACK_IMPORTED_MODULE_0__/* .getVideoLink */ .rp)(url);
    }
    this.setState({
        overlayOn: !this.state.externalPopupOn,
        externalPopupOn: !this.state.externalPopupOn,
        externalPopupUrl: externalPopupUrl,
        markerPopupOn: false,
        iframeSettings: iframeSettings
    });
}
function toggleContactPopup() {
    if (!this.state.contactPopupOn) {
        (0,_analytic__WEBPACK_IMPORTED_MODULE_1__/* .sendToGA */ .o$)("event", {
            eventCategory: "Contact",
            eventAction: "click",
            eventLabel: "open"
        });
        (0,_analytic__WEBPACK_IMPORTED_MODULE_1__/* .sendToGA */ .o$)("event", {
            eventCategory: "Lead",
            eventAction: "open",
            eventLabel: "contact"
        });
    }
    this.setState({
        contactPopupOn: !this.state.contactPopupOn,
        overlayOn: !this.state.contactPopupOn
    });
}


/***/ }),

/***/ 68687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k$": function() { return /* binding */ getLocation; },
  "u7": function() { return /* binding */ loadModel; },
  "QO": function() { return /* binding */ moveToMPLabels; },
  "h_": function() { return /* binding */ navigateToTag; },
  "$O": function() { return /* binding */ openTagIframe; },
  "IW": function() { return /* binding */ openVsImageIframe; },
  "BY": function() { return /* binding */ openVsObjectIframe; },
  "O7": function() { return /* binding */ openVsVideoIframe; },
  "Z4": function() { return /* binding */ openedPanoHotspot; },
  "$v": function() { return /* binding */ preventTagAction; },
  "Zy": function() { return /* binding */ takePano; },
  "ss": function() { return /* binding */ takeScreenshot; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/downloadjs/download.js
var download = __webpack_require__(33729);
var download_default = /*#__PURE__*/__webpack_require__.n(download);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./node_modules/watermarkjs/dist/watermark.js
var watermark = __webpack_require__(60832);
var watermark_default = /*#__PURE__*/__webpack_require__.n(watermark);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 328 modules
var dist = __webpack_require__(78734);
// EXTERNAL MODULE: ./_models/Tag.tsx
var Tag = __webpack_require__(42725);
// EXTERNAL MODULE: ./_models/Menu.tsx
var Menu = __webpack_require__(78073);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./_models/game/GameBook.ts
var GameBook = __webpack_require__(97741);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./components/util/socket.ts
var socket = __webpack_require__(13607);
// EXTERNAL MODULE: ./components/util/analytic.ts
var analytic = __webpack_require__(83784);
// EXTERNAL MODULE: ./components/util/index.ts + 6 modules
var util = __webpack_require__(66870);
;// CONCATENATED MODULE: ./components/tour/processNavigationPath.ts





var processNavigationPath = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var url, sweeps, startSweep, cb, THREE, sr, ss, linkDataShort, x, y, z, euler, rotation, endSweep, sweepsPath;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    url = param.tagNavigationLink, sweeps = param.sweeps, startSweep = param.startSweep, cb = param.cb;
                    _ctx.next = 3;
                    return (0,dist/* iTHREE */.Sc)();
                case 3:
                    THREE = _ctx.sent;
                    sr = (0,util/* getQueryVariable */.Dv)(url, "sr");
                    ss = (0,util/* getQueryVariable */.Dv)(url, "ss");
                    linkDataShort = sr && ss ? {
                        sr: sr.split(","),
                        ss: parseInt(String(ss), 10)
                    } : false;
                    if (linkDataShort) {
                        x = parseFloat(linkDataShort.sr[0] || "0");
                        y = parseFloat(linkDataShort.sr[1] || "0");
                        z = parseFloat(linkDataShort.sr[2] || "0");
                        euler = new THREE.Euler().set(x, y, z, "XYZ").reorder("YXZ");
                        rotation = new THREE.Vector3(euler.x, euler.y, euler.z).multiplyScalar(180 / Math.PI); // @ts-ignore
                        rotation.z = 0;
                        endSweep = sweeps[linkDataShort.ss - 1].uuid;
                        sweepsPath = (0,util/* getSweepsPath */.u6)(sweeps, startSweep, endSweep);
                        cb({
                            sweepsPath: sweepsPath,
                            rotation: rotation
                        });
                    } else {
                        react_toastify_esm/* toast.error */.Am.error("Wrong matterport deep link");
                    }
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function processNavigationPath(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_iterator.mjs
var _async_iterator = __webpack_require__(2236);
;// CONCATENATED MODULE: ./components/tour/moveToSweeps.ts



/* eslint-disable no-restricted-syntax */ 

var moveToSweeps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var sweepsPath, targetRotation, poseRotation, rotationAngle, rotationSpeed, transitionSpeed, stopAfterSweep, showcaseSweep, iteration, currentRotation, maxSpeed, minSpeed, delay, THREE, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, id, rotation, next, currentSpeed, curQuaternion, nextQuaternion, angle;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    sweepsPath = param.sweepsPath, targetRotation = param.targetRotation, poseRotation = param.poseRotation, rotationAngle = param.rotationAngle, rotationSpeed = param.rotationSpeed, transitionSpeed = param.transitionSpeed, stopAfterSweep = param.stopAfterSweep, showcaseSweep = param.showcaseSweep;
                    iteration = 0;
                    currentRotation = poseRotation;
                    maxSpeed = 5000;
                    minSpeed = 500;
                    delay = 5000;
                    _ctx.next = 8;
                    return (0,dist/* iTHREE */.Sc)();
                case 8:
                    THREE = _ctx.sent;
                    if (!showcaseSweep) {
                        _ctx.next = 46;
                        break;
                    }
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _ctx.prev = 11;
                    _iterator = (0,_async_iterator/* default */.Z)(sweepsPath);
                case 13:
                    _ctx.next = 15;
                    return _iterator.next();
                case 15:
                    if (!(_iteratorAbruptCompletion = !(_step = _ctx.sent).done)) {
                        _ctx.next = 29;
                        break;
                    }
                    _value = _step.value;
                    id = _value.id, rotation = _value.rotation, next = _value.next;
                    currentSpeed = transitionSpeed;
                    if (next) {
                        curQuaternion = new THREE.Quaternion(rotation.x, rotation.y, rotation.z, rotation.w);
                        nextQuaternion = new THREE.Quaternion(next.rotation.x, next.rotation.y, next.rotation.z, next.rotation.w);
                        angle = curQuaternion.angleTo(nextQuaternion) * 180 / Math.PI;
                        if (angle > rotationAngle) {
                            currentRotation.y += angle;
                            currentSpeed = rotationSpeed;
                        }
                    } else {
                        currentRotation = targetRotation;
                    }
                    _ctx.next = 22;
                    return showcaseSweep.moveTo(id, {
                        rotation: currentRotation,
                        transition: showcaseSweep.Transition.FLY,
                        transitionTime: maxSpeed + minSpeed - maxSpeed * currentSpeed / 100
                    });
                case 22:
                    if (!(iteration > 0 && iteration !== sweepsPath.length - 1 && !(iteration % stopAfterSweep))) {
                        _ctx.next = 25;
                        break;
                    }
                    _ctx.next = 25;
                    return new Promise(function(resolve) {
                        return setTimeout(resolve, delay);
                    });
                case 25:
                    iteration += 1;
                case 26:
                    _iteratorAbruptCompletion = false;
                    _ctx.next = 13;
                    break;
                case 29:
                    _ctx.next = 35;
                    break;
                case 31:
                    _ctx.prev = 31;
                    _ctx.t0 = _ctx["catch"](11);
                    _didIteratorError = true;
                    _iteratorError = _ctx.t0;
                case 35:
                    _ctx.prev = 35;
                    _ctx.prev = 36;
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                        _ctx.next = 40;
                        break;
                    }
                    _ctx.next = 40;
                    return _iterator.return();
                case 40:
                    _ctx.prev = 40;
                    if (!_didIteratorError) {
                        _ctx.next = 43;
                        break;
                    }
                    throw _iteratorError;
                case 43:
                    return _ctx.finish(40);
                case 44:
                    return _ctx.finish(35);
                case 45:
                    return _ctx.abrupt("return", Promise.resolve());
                case 46:
                    react_toastify_esm/* toast.error */.Am.error("Wait for the model to load");
                    return _ctx.abrupt("return", Promise.reject());
                case 48:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                11,
                31,
                35,
                45
            ],
            [
                36,
                ,
                40,
                44
            ]
        ]);
    }));
    return function moveToSweeps(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./_models/Game.tsx
var Game = __webpack_require__(81766);
;// CONCATENATED MODULE: ./components/util/sdk.ts




















function downloadDirect(url, title) {
    var element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("download", "".concat(title, ".jpg"));
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
function takePano() {
    if (this.showcase) {
        var _this = this;
        this.setState({
            loading: true
        });
        this.showcase.Renderer.takeEquirectangular().then(function(url) {
            downloadDirect(url, _this.state.tour.title);
            _this.setState({
                loading: false
            });
        });
    }
}
function getLocation() {
    var m = (0,util_all/* getQueryVariable */.Dv)(this.state.iframeUrl, "m");
    if (m) {
        return (0,util_all/* buildLink */.DF)(this.pose.sweep, this.pose.rotation, btoa(encodeURIComponent(m)));
    }
    return null;
}
function downloadImage(title, url, clientId, width) {
    var options = {
        init: function init(img) {
            // eslint-disable-next-line no-param-reassign
            img.crossOrigin = "anonymous";
        }
    };
    watermark_default()([
        url,
        "".concat("https://cdn.treedis.com", "/clients/").concat(clientId, "/logo.png").concat((0,util_all/* getVersion */.bo)(new Date()))
    ], options).blob(function(target, _watermark) {
        var context = target.getContext("2d");
        context.save();
        var widthRatio = _watermark.width / width;
        var height = _watermark.height / widthRatio;
        context.drawImage(_watermark, 10, 10, width, height);
        context.restore();
        return target;
    }).then(function(img) {
        return download_default()(img, "".concat(title, ".jpg"), "image/jpg");
    });
}
function takeScreenshot(resolution) {
    if (this.showcase) {
        var _this = this;
        var tour = this.state.tour;
        var width = tour.client && tour.client.widthLogo ? 250 : 150;
        this.setState({
            loading: true
        });
        this.showcase.Renderer.takeScreenShot(resolution, {
            mattertags: false,
            sweeps: false
        }).then(function(url) {
            if (tour.client && tour.client.logo) {
                downloadImage(tour.title, url, tour.clientId, width);
            } else {
                downloadDirect(url, tour.title);
            }
            _this.setState({
                loading: false
            });
        });
    }
}
function preventTagAction(sid, actions) {
    var ref;
    if ((ref = this) === null || ref === void 0 ? void 0 : ref.showcase) {
        // eslint-disable-next-line no-console
        return this.showcase.Mattertag.preventAction(sid, actions).catch(console.error);
    }
    return null;
}
function navigateToTag(sid) {
    return _navigateToTag.apply(this, arguments);
}
function _navigateToTag() {
    _navigateToTag = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sid) {
        var ref, preventAction;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!((ref = this) === null || ref === void 0 ? void 0 : ref.showcase)) {
                        _ctx.next = 9;
                        break;
                    }
                    preventAction = preventTagAction.bind(this);
                    _ctx.next = 5;
                    return preventAction(sid, {
                        navigation: false
                    });
                case 5:
                    _ctx.next = 7;
                    return this.showcase.Mattertag.navigateToTag(sid, this.showcase.Mattertag.Transition.FLY).catch(console.error);
                case 7:
                    _ctx.next = 9;
                    return preventAction(sid, {
                        navigation: true
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, this);
    }));
    return _navigateToTag.apply(this, arguments);
}
function loadModel(name, url, type, tag, panoramaId) {
    var changeMinimap = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true, changePanorama = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, iframeSettings = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {};
    if (type === Menu/* MenuType.Tab */.o.Tab) {
        window.open(url);
    } else if (type === Menu/* MenuType.Popup */.o.Popup) {
        this.toggleExternalPopup(url);
    } else if (type === Menu/* MenuType.Iframe */.o.Iframe) {
        this.toggleExternalPopup(url, iframeSettings);
    } else if (type === Menu/* MenuType.Product */.o.Product && tag !== null) {
        var products = this.state.products.filter(function(item) {
            return ((item === null || item === void 0 ? void 0 : item.tags) || []).some(function(productTag) {
                return productTag.sid === tag;
            });
        });
        if (products && products.length > 0) {
            this.setState({
                currentProducts: products.length > 1 ? products : [],
                currentProduct: products.length === 1 ? products[0] : null
            });
        }
        navigateToTag(tag);
        window.location.hash = tag;
    } else if (type === Menu/* MenuType.Panorama */.o.Panorama) {
        this.setState({
            panoramaOn: true,
            activePano: panoramaId
        });
    } else if (type === Menu/* MenuType.Treedis */.o.Treedis) {
        var tour = this.state.tour;
        var segments = url.split("/");
        var lastSeg = segments[segments.length - 1].split("?");
        var id = lastSeg[0];
        var sameTour = tour.slug === id;
        if (sameTour && lastSeg.length === 1) return; // same tour, no query params, we shouldn't get it again
        if (url.includes("matterport.com")) {
            react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
            return;
        }
        var _this = this;
        // if isVSReady is true, then VS is configured (VS components, lights etc.) - can't init VS without it
        // don't need to configure that if it's the same tour
        this.setState({
            panoramaOn: false,
            activePano: null,
            isVSReady: sameTour
        }, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this.getTour({
                            id: id,
                            changeMenu: false,
                            changeMinimap: changeMinimap,
                            changePanorama: changePanorama,
                            url: url,
                            hideIntroScreen: true
                        }); // false = dont change the menu/panorama
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })));
    } else if (type === Menu/* MenuType.MatterportInstant */.o.MatterportInstant) {
        var _this1 = this;
        this.setState({
            isChangeIframe: this.state.iframeUrl.matterId !== (0,util_all/* getQueryVariable */.Dv)(url, "m")
        }, function() {
            var ref, ref1;
            _this1.moveModel("/mp-sdk/".concat("3.1.76", "/showcase.html?applicationKey=").concat((ref = _this1.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(url)), false, true);
        });
    } else if (type === Menu/* MenuType.Tag */.o.Tag && tag !== null) {
        var _this2 = this;
        var target = Array.from(this.state.allTags, function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
            return value;
        })// searching by temporary sid from Matterport
        .find(function(item) {
            return item.sid === tag || item.defaultSid === tag;
        });
        if (!target) {
            react_toastify_esm/* toast.error */.Am.error("Cannot find the tag on the tour");
            return;
        }
        this.setState({
            panoramaOn: false
        }, function() {
            _this2.moveToTagIO(target, false);
        });
    } else {
        var _this3 = this;
        this.setState({
            isChangeIframe: this.state.iframeUrl.matterId !== (0,util_all/* getQueryVariable */.Dv)(url, "m")
        }, function() {
            var ref, ref1;
            _this3.moveModel("/mp-sdk/".concat("3.1.76", "/showcase.html?applicationKey=").concat((ref = _this3.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(url)), false, false);
        });
    }
    if (name) {
        (0,analytic/* sendToGA */.o$)("event", {
            eventCategory: "Place",
            eventAction: "click",
            eventLabel: name
        });
    }
    if (name && this.state.chatToken && socket/* default */.Z && socket/* default.connected */.Z.connected && this.state.host) {
        socket/* default.emit */.Z.emit("menu", {
            menu: {
                name: name,
                url: url,
                type: type
            }
        });
    }
}
function openedPanoHotspot(hotspot) {
    return _openedPanoHotspot.apply(this, arguments);
}
function _openedPanoHotspot() {
    _openedPanoHotspot = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(hotspot) {
        var ref, ref1, ref2, ref3, segments, id, isHubUrl, room, tour, changeMinimap, _this, _state, tour1, panoramas, panorama, src, audioContainer, _this1, play, ref4, noAudioMode;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(hotspot.type === Tag/* TagType.Matterport */.Qy.Matterport && hotspot.url)) {
                        _ctx.next = 4;
                        break;
                    }
                    ;
                    this.moveModel("/mp-sdk/".concat("3.1.76", "/showcase.html?applicationKey=").concat((ref = this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(hotspot.url)), false, true);
                    return _ctx.abrupt("return");
                case 4:
                    if (!(hotspot.type === Tag/* TagType.MatterportInstant */.Qy.MatterportInstant && hotspot.url)) {
                        _ctx.next = 8;
                        break;
                    }
                    ;
                    this.moveModel("/mp-sdk/".concat("3.1.76", "/showcase.html?applicationKey=").concat((ref2 = this.state.tour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(hotspot.url)), false, false);
                    return _ctx.abrupt("return");
                case 8:
                    if (!(hotspot.type === Tag/* TagType.Treedis */.Qy.Treedis && hotspot.url)) {
                        _ctx.next = 24;
                        break;
                    }
                    segments = hotspot.url.split("/");
                    id = hotspot.url.includes("?") ? segments[segments.length - 1].split("?")[0] : segments[4];
                    isHubUrl = hotspot.url.includes("host") || hotspot.url.includes("guest");
                    room = isHubUrl ? segments[segments.length - 1] : null;
                    if (!(0,util_all/* getQueryVariable */.Dv)(hotspot.url, "m")) {
                        _ctx.next = 16;
                        break;
                    }
                    react_toastify_esm/* toast.error */.Am.error("Can't use this link, to copy location in treedis tour, use CTRL+Y");
                    return _ctx.abrupt("return");
                case 16:
                    tour = this.state.tour;
                    changeMinimap = tour && !tour.customMinimap;
                    _ctx.next = 20;
                    return this.getTour({
                        id: id,
                        changeMenu: false,
                        changeMinimap: changeMinimap,
                        changePanorama: false,
                        url: hotspot.url
                    });
                case 20:
                    if (!socket/* default.connected */.Z.connected && isHubUrl) {
                        socket/* default.open */.Z.open();
                    }
                    _this = this;
                    this.setState({
                        panoramaOn: false,
                        activePano: null,
                        isVSReady: false,
                        room: room
                    }, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    if (_this.state.chatToken && socket/* default */.Z && socket/* default.connected */.Z.connected && _this.state.host) {
                                        socket/* default.emit */.Z.emit("pano-hotspot-click", {
                                            id: id,
                                            changeMenu: false,
                                            changeMinimap: changeMinimap,
                                            changePanorama: false,
                                            url: hotspot.url
                                        });
                                    }
                                case 1:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    })));
                    return _ctx.abrupt("return");
                case 24:
                    if (!(hotspot.type === Tag/* TagType.Music */.Qy.Music && hotspot.url)) {
                        _ctx.next = 36;
                        break;
                    }
                    _state = this.state, tour1 = _state.tour, panoramas = _state.panoramas;
                    if (!(tour1.noAudioMode && this.state.chatToken)) {
                        _ctx.next = 28;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 28:
                    panorama = panoramas.find(function(p) {
                        return p.id === hotspot.panoramaId;
                    });
                    src = "".concat("https://cdn.treedis.com", "/tours/").concat(tour1.id, "/panoramas/").concat(panorama.url, "/").concat(hotspot.url);
                    audioContainer = this.getAudioContainer("panoramaAudio");
                    if ((audioContainer === null || audioContainer === void 0 ? void 0 : audioContainer.hotspotId) !== hotspot.id) {
                        audioContainer === null || audioContainer === void 0 ? void 0 : audioContainer.pause();
                        audioContainer = this.createAudioStream("panoramaAudio", src);
                        audioContainer.hotspotId = hotspot.id;
                    }
                    _this1 = this;
                    play = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            var status;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.prev = 0;
                                        _ctx.next = 3;
                                        return _this1.pauseAllAudio("panoramaAudio");
                                    case 3:
                                        _ctx.next = 5;
                                        return _this1.playContainerAudio("panoramaAudio");
                                    case 5:
                                        status = _ctx.sent;
                                        _this1.setState({
                                            mainPlaying: false,
                                            otherPlaying: status
                                        });
                                        _ctx.next = 12;
                                        break;
                                    case 9:
                                        _ctx.prev = 9;
                                        _ctx.t0 = _ctx["catch"](0);
                                        setTimeout(play, 500);
                                    case 12:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    0,
                                    9
                                ]
                            ]);
                        }));
                        return function play() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    play();
                    return _ctx.abrupt("return");
                case 36:
                    if (hotspot.type === Tag/* TagType.Video */.Qy.Video && hotspot.url) {
                        ;
                        noAudioMode = ((ref4 = this.state) === null || ref4 === void 0 ? void 0 : ref4.tour).noAudioMode;
                        hotspot.url = (0,util_all/* getVideoLink */.rp)(hotspot.url, {
                            mute: noAudioMode && this.state.chatToken
                        });
                    }
                    this.setState({
                        panoPopOn: true,
                        openedPanoHotspot: hotspot
                    });
                case 38:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, this);
    }));
    return _openedPanoHotspot.apply(this, arguments);
}
function openTagIframe(sid) {
    return _openTagIframe.apply(this, arguments);
}
function _openTagIframe() {
    _openTagIframe = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sid) {
        var _state, allTags, tour, tourType, foundTag, tag, ref, _this, segmants, lastSeg, id, changeMinimap, _this1, ref1, ref2, ref3, ref4, _this2, ref5, noAudioMode, ref6, noAudioMode1, src, audioContainer, _this3, play;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _state = this.state, allTags = _state.allTags, tour = _state.tour, tourType = _state.tourType;
                    foundTag = Array.from(allTags, function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                        return value;
                    })// searching by temporary sid from Matterport
                    .find(function(item) {
                        return item.sid === sid || item.defaultSid === sid;
                    });
                    if (!foundTag) {
                        _ctx.next = 77;
                        break;
                    }
                    if (!(!foundTag.enabled || !foundTag.type)) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 5:
                    tag = (0,_object_spread/* default */.Z)({}, foundTag);
                    if (!(tag.type === "video")) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.next = 9;
                    return this.pauseTourMusic();
                case 9:
                    if (!((tour === null || tour === void 0 ? void 0 : tour.gameId) && tourType === Tour/* TourType.Game */.v.Game)) {
                        _ctx.next = 15;
                        break;
                    }
                    this.unlockChapter(tag, GameBook/* ChapterType.Tag */._U.Tag);
                    if (!this.handleTagLock(tag)) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 13:
                    _ctx.next = 16;
                    break;
                case 15:
                    if (tour === null || tour === void 0 ? void 0 : tour.gameId) {
                        this.setState({
                            clickedElement: {
                                id: tag.id,
                                type: Game/* EntityType.Tag */.py.Tag
                            }
                        });
                    }
                case 16:
                    if (!((tag === null || tag === void 0 ? void 0 : tag.type) === Tag/* TagType.None */.Qy.None)) {
                        _ctx.next = 18;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 18:
                    if (!((tag === null || tag === void 0 ? void 0 : tag.type) === Tag/* TagType.Navigation */.Qy.Navigation)) {
                        _ctx.next = 22;
                        break;
                    }
                    ;
                    if ((ref = this.state.tour) === null || ref === void 0 ? void 0 : ref.showNavTools) {
                        _this = this;
                        processNavigationPath({
                            tagNavigationLink: tag.navigationLink,
                            sweeps: this.state.sweeps,
                            startSweep: this.pose.sweep,
                            cb: function(param) {
                                var sweepsPath = param.sweepsPath, rotation = param.rotation;
                                var _this1 = _this;
                                var _tour = _this.state.tour, rotationAngle = _tour.rotationAngle, rotationSpeed = _tour.rotationSpeed, transitionSpeed = _tour.transitionSpeed, stopAfterSweep = _tour.stopAfterSweep;
                                moveToSweeps({
                                    sweepsPath: sweepsPath,
                                    targetRotation: rotation,
                                    rotationAngle: rotationAngle,
                                    rotationSpeed: rotationSpeed,
                                    transitionSpeed: transitionSpeed,
                                    stopAfterSweep: stopAfterSweep,
                                    poseRotation: _this.pose.rotation,
                                    showcaseSweep: _this.showcase.Sweep
                                }).then(function() {
                                    _this1.setState({
                                        showPathFinderPopup: true
                                    });
                                });
                            }
                        });
                    }
                    return _ctx.abrupt("return", null);
                case 22:
                    if (!(tag.embedMedia && [
                        Tag/* TagType.Image */.Qy.Image,
                        Tag/* TagType.Video */.Qy.Video,
                        Tag/* TagType.Iframe */.Qy.Iframe,
                        Tag/* TagType.Text */.Qy.Text
                    ].includes(tag.type))) {
                        _ctx.next = 24;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 24:
                    if (!(tag.type === Tag/* TagType.Panorama */.Qy.Panorama)) {
                        _ctx.next = 27;
                        break;
                    }
                    this.setState({
                        activePano: tag.panoramaId,
                        panoramaOn: true
                    });
                    return _ctx.abrupt("return", null);
                case 27:
                    if (!(tag.type === Tag/* TagType.Treedis */.Qy.Treedis && tag.url)) {
                        _ctx.next = 40;
                        break;
                    }
                    segmants = tag.url.split("/");
                    lastSeg = segmants[segmants.length - 1].split("?");
                    id = lastSeg[0];
                    if (!(tour.slug === id && lastSeg.length === 1)) {
                        _ctx.next = 33;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 33:
                    if (!(0,util_all/* getQueryVariable */.Dv)(tag.url, "m")) {
                        _ctx.next = 36;
                        break;
                    }
                    react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
                    return _ctx.abrupt("return", null);
                case 36:
                    changeMinimap = tour && !tour.customMinimap;
                    _this1 = this;
                    // isVSReady - the VS should be initialized again
                    this.setState({
                        panoramaOn: false,
                        activePano: null,
                        isVSReady: false
                    }, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.next = 2;
                                    return _this1.stopVS();
                                case 2:
                                    _this1.modelNodes = [];
                                    _this1.vsObjects = [];
                                    _this1.getTour({
                                        id: id,
                                        changeMenu: false,
                                        changeMinimap: changeMinimap,
                                        changePanorama: false,
                                        url: tag.url,
                                        hideIntroScreen: true
                                    }); // false = dont change the menu/panorama
                                case 5:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    })));
                    return _ctx.abrupt("return", null);
                case 40:
                    if (!(tag.type === Tag/* TagType.MatterportInstant */.Qy.MatterportInstant && tag.url)) {
                        _ctx.next = 44;
                        break;
                    }
                    ;
                    this.moveModel("/mp-sdk/".concat("3.1.76", "/showcase.html?applicationKey=").concat((ref1 = this.state.tour) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.user) === null || ref2 === void 0 ? void 0 : ref2.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(tag.url)), false, true);
                    return _ctx.abrupt("return", null);
                case 44:
                    if (!(tag.type === Tag/* TagType.Matterport */.Qy.Matterport && tag.url)) {
                        _ctx.next = 48;
                        break;
                    }
                    ;
                    this.moveModel("/mp-sdk/".concat("3.1.76", "/showcase.html?applicationKey=").concat((ref3 = this.state.tour) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.user) === null || ref4 === void 0 ? void 0 : ref4.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(tag.url)), false, false);
                    return _ctx.abrupt("return", null);
                case 48:
                    if (!(tag.type === Tag/* TagType.Menu */.Qy.Menu)) {
                        _ctx.next = 52;
                        break;
                    }
                    _this2 = this;
                    this.setState({
                        menuOpen: false,
                        activeMenu: null
                    }, function() {
                        _this2.setState({
                            menuOpen: true,
                            menuOpened: true,
                            activeMenu: {
                                id: tag.menuId,
                                subMenu: tag.subMenuId,
                                subSubMenu: tag.subSubMenuId
                            }
                        });
                    });
                    return _ctx.abrupt("return", null);
                case 52:
                    if (tag.type === Tag/* TagType.Video */.Qy.Video && tag.url) {
                        ;
                        noAudioMode = ((ref5 = this.state) === null || ref5 === void 0 ? void 0 : ref5.tour).noAudioMode;
                        tag.url = (0,util_all/* getVideoLink */.rp)(tag.url, {
                            mute: noAudioMode && this.state.chatToken,
                            autoplay: tag.autoPlay
                        });
                        this.pauseAllAudio();
                    }
                    if (!(tag.type === Tag/* TagType.Tab */.Qy.Tab && tag.url)) {
                        _ctx.next = 56;
                        break;
                    }
                    window.open(tag.url);
                    return _ctx.abrupt("return", null);
                case 56:
                    if (!(tag.type === Tag/* TagType.Music */.Qy.Music && tag.url)) {
                        _ctx.next = 68;
                        break;
                    }
                    ;
                    noAudioMode1 = ((ref6 = this.state) === null || ref6 === void 0 ? void 0 : ref6.tour).noAudioMode;
                    if (!(noAudioMode1 && this.state.chatToken)) {
                        _ctx.next = 61;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 61:
                    src = "".concat("https://cdn.treedis.com", "/tours/").concat(this.state.tour.id, "/tags/").concat(tag.url);
                    audioContainer = this.getAudioContainer("tagAudio");
                    if ((audioContainer === null || audioContainer === void 0 ? void 0 : audioContainer.tagId) !== tag.id) {
                        audioContainer = this.createAudioStream("tagAudio", src, true);
                        audioContainer.tagId = tag.id;
                    }
                    _this3 = this;
                    play = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            var status;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.prev = 0;
                                        _ctx.next = 3;
                                        return _this3.pauseAllAudio("tagAudio");
                                    case 3:
                                        _ctx.next = 5;
                                        return _this3.playContainerAudio("tagAudio");
                                    case 5:
                                        status = _ctx.sent;
                                        _this3.setState({
                                            mainPlaying: false,
                                            otherPlaying: status
                                        });
                                        _ctx.next = 13;
                                        break;
                                    case 9:
                                        _ctx.prev = 9;
                                        _ctx.t0 = _ctx["catch"](0);
                                        if ((0,_instanceof/* default */.Z)(_ctx.t0, DOMException)) {
                                            // eslint-disable-next-line no-console
                                            console.error(_ctx.t0.message);
                                        }
                                        setTimeout(play, 500);
                                    case 13:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    0,
                                    9
                                ]
                            ]);
                        }));
                        return function play() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    play();
                    return _ctx.abrupt("return", null);
                case 68:
                    if (!(tag.type === Tag/* TagType.VideoChat */.Qy.VideoChat)) {
                        _ctx.next = 72;
                        break;
                    }
                    this.setState({
                        videoChatTagPopOn: true,
                        openedTag: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tag), {
                            sid: tag.sid
                        })
                    });
                    this.pauseAllAudio();
                    return _ctx.abrupt("return", null);
                case 72:
                    if (!(tag.type === Tag/* TagType.ConferenceChat */.Qy.ConferenceChat)) {
                        _ctx.next = 75;
                        break;
                    }
                    this.setState({
                        chatOpen: true,
                        chatRoom: {
                            tag: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tag), {
                                sid: tag.sid
                            }),
                            client: tag === null || tag === void 0 ? void 0 : tag.client
                        }
                    });
                    return _ctx.abrupt("return", null);
                case 75:
                    this.setState({
                        tagPopOn: true,
                        openedTag: tag,
                        closedElementPopup: false
                    });
                    return _ctx.abrupt("return", tag);
                case 77:
                    return _ctx.abrupt("return", null);
                case 78:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, this);
    }));
    return _openTagIframe.apply(this, arguments);
}
function moveToMPLabels(menu) {
    return _moveToMPLabels.apply(this, arguments);
}
function _moveToMPLabels() {
    _moveToMPLabels = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(menu) {
        var type, labelId, floorId, _state, mpLabels, sweeps, mpFloors, THREE, floorIndex, label, sweepsOnFloor, startPoint, distances, sweepsWithMinDistance;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    type = menu.type, labelId = menu.labelId, floorId = menu.floorId;
                    _state = this.state, mpLabels = _state.mpLabels, sweeps = _state.sweeps, mpFloors = _state.mpFloors;
                    _ctx.next = 4;
                    return (0,dist/* iTHREE */.Sc)();
                case 4:
                    THREE = _ctx.sent;
                    _ctx.prev = 5;
                    _ctx.t0 = type;
                    _ctx.next = _ctx.t0 === Menu/* MenuType.MatterportFloor */.o.MatterportFloor ? 9 : _ctx.t0 === Menu/* MenuType.MatterportLabel */.o.MatterportLabel ? 15 : 25;
                    break;
                case 9:
                    floorIndex = mpFloors.findIndex(function(l) {
                        return String(l.id) === String(floorId);
                    });
                    _ctx.next = 12;
                    return this.changeViewMode(Tour/* TourMode.FLOORPLAN */.zz.FLOORPLAN);
                case 12:
                    _ctx.next = 14;
                    return this.changeFloor(floorIndex);
                case 14:
                    return _ctx.abrupt("break", 27);
                case 15:
                    label = mpLabels.find(function(l) {
                        return l.sid === labelId;
                    });
                    if (!label) console.error("Label not found");
                    sweepsOnFloor = sweeps.filter(function(x) {
                        return x.floorInfo.id === label.floorInfo.id && x.enabled;
                    });
                    if (sweepsOnFloor.length === 0) console.error("Sweeps not found");
                    startPoint = new THREE.Vector3(label.position.x, label.position.y, label.position.z);
                    distances = sweepsOnFloor.map(function(sweep) {
                        var endPoint = new THREE.Vector3(sweep.position.x, sweep.position.y, sweep.position.z);
                        var distance = Math.abs(startPoint.distanceTo(endPoint));
                        return (0,_object_spread/* default */.Z)({
                            distance: distance
                        }, sweep);
                    });
                    sweepsWithMinDistance = distances.reduce(function(a, b) {
                        return (a === null || a === void 0 ? void 0 : a.distance) <= (b === null || b === void 0 ? void 0 : b.distance) ? a : b;
                    });
                    _ctx.next = 24;
                    return this.showcase.Sweep.moveTo(sweepsWithMinDistance["id"], {
                        // eslint-disable-next-line dot-notation
                        rotation: sweepsWithMinDistance["rotation"],
                        transition: this.showcase.Mode.TransitionType.FLY
                    });
                case 24:
                    return _ctx.abrupt("break", 27);
                case 25:
                    console.error("moveToMPLabels: Menu type unknown");
                    return _ctx.abrupt("break", 27);
                case 27:
                    _ctx.next = 32;
                    break;
                case 29:
                    _ctx.prev = 29;
                    _ctx.t1 = _ctx["catch"](5);
                    console.error(_ctx.t1);
                case 32:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, this, [
            [
                5,
                29
            ]
        ]);
    }));
    return _moveToMPLabels.apply(this, arguments);
}
function openVsObjectIframe(vsObject) {
    return _openVsObjectIframe.apply(this, arguments);
}
function _openVsObjectIframe() {
    _openVsObjectIframe = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(vsObject) {
        var tour;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    tour = this.state.tour;
                    if (!(tour === null || tour === void 0 ? void 0 : tour.gameId)) {
                        _ctx.next = 5;
                        break;
                    }
                    this.unlockChapter(vsObject, GameBook/* ChapterType.VSItem */._U.VSItem);
                    if (!this.handleVsObjectLock(vsObject, Game/* LockLocationType.vsItem */.A.vsItem)) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, this);
    }));
    return _openVsObjectIframe.apply(this, arguments);
}
function openVsImageIframe(vsImage) {
    return _openVsImageIframe.apply(this, arguments);
}
function _openVsImageIframe() {
    _openVsImageIframe = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(vsImage) {
        var tour;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    tour = this.state.tour;
                    if (!(tour === null || tour === void 0 ? void 0 : tour.gameId)) {
                        _ctx.next = 5;
                        break;
                    }
                    this.unlockChapter(vsImage, GameBook/* ChapterType.VSImage */._U.VSImage);
                    if (!this.handleVsObjectLock(vsImage, Game/* LockLocationType.vsImage */.A.vsImage)) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, this);
    }));
    return _openVsImageIframe.apply(this, arguments);
}
function openVsVideoIframe(vsVideo) {
    return _openVsVideoIframe.apply(this, arguments);
}
function _openVsVideoIframe() {
    _openVsVideoIframe = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(vsVideo) {
        var tour;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    tour = this.state.tour;
                    if (!(tour === null || tour === void 0 ? void 0 : tour.gameId)) {
                        _ctx.next = 5;
                        break;
                    }
                    this.unlockChapter(vsVideo, GameBook/* ChapterType.VSVideo */._U.VSVideo);
                    if (!this.handleVsObjectLock(vsVideo, Game/* LockLocationType.vsVideo */.A.vsVideo)) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, this);
    }));
    return _openVsVideoIframe.apply(this, arguments);
}


/***/ }),

/***/ 13607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

var io = (__webpack_require__(57046).io);
// import { toast } from "react-toastify";
// @ts-ignore
var socket = io("https://sockets.treedis.com" || 0, {
    transports: [
        "websocket"
    ],
    autoConnect: false
});
socket.on("connect_error", function(err) {
    // eslint-disable-next-line no-console
    console.error(err);
});
/* harmony default export */ __webpack_exports__["Z"] = (socket);


/***/ }),

/***/ 24069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U_": function() { return /* binding */ calculateMobileHeight; }
/* harmony export */ });
/* unused harmony exports customSelectStyles, newEcommerceStyles, ecommerceDefaultColorBlackSelect */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var customSelectStyles = {
    control: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            minHeight: 38,
            borderRadius: 0,
            maxHeight: "40px",
            height: "40px",
            borderColor: "#D9EAEC",
            color: "red"
        });
    },
    input: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "100%",
            margin: 0,
            padding: 0,
            color: "green"
        });
    },
    indicatorSeparator: function() {
        return {
            display: "none",
            color: "blue"
        };
    },
    indicatorsContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    singleValue: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            fontWeight: "normal",
            cursor: "pointer",
            transform: "none",
            border: "none",
            top: "0",
            height: "40px",
            lineHeight: "40px"
        });
    },
    valueContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px",
            color: "red"
        });
    },
    placeholder: function(base) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, base), {
            display: "none",
            color: "red"
        });
    }
};
var newEcommerceStyles = {
    control: function(provided, props) {
        var styles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            minHeight: 38,
            borderRadius: 0,
            maxHeight: "40px",
            height: "40px"
        });
        if (props === null || props === void 0 ? void 0 : props.isDisabled) {
            styles.backgroundColor = "rgba(239, 239, 239, 0.3)";
            styles.borderColor = "rgba(239, 239, 239, 0.3)";
        }
        return styles;
    },
    input: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "100%",
            margin: 0,
            padding: 0,
            color: "black"
        });
    },
    indicatorSeparator: function() {
        return {
            display: "none"
        };
    },
    indicatorsContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    singleValue: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            fontWeight: "normal",
            cursor: "pointer",
            transform: "none",
            border: "none",
            top: "0",
            height: "40px",
            lineHeight: "40px",
            color: "black"
        });
    },
    valueContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    placeholder: function(base) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, base);
    },
    option: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            color: "black"
        });
    }
};
var ecommerceDefaultColorBlackSelect = {
    input: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            color: "black"
        });
    },
    indicatorSeparator: function() {
        return {
            display: "none"
        };
    },
    indicatorsContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    singleValue: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            color: "black"
        });
    },
    valueContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    placeholder: function(base) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, base);
    },
    option: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            color: "black"
        });
    }
};
var calculateMobileHeight = function() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
};


/***/ })

}]);